import { render } from "./Transparency.html?vue&type=template&id=81765c2e&ts=true"
import script from "./Transparency.vue?vue&type=script&lang=ts"
export * from "./Transparency.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devgeorge/andrea/webpage_curaduria2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__